module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-3-1391c7c06e715e679bee7b848b5a657a.png";